import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { FaCheckSquare } from "react-icons/fa";
import "./talentinfrastructure.css";

const stats = [
  {
    number: 86000,
    suffix: "+",
    title: "Software",
    subtitle: "Engineers",
  },
  {
    number: 71000,
    suffix: "+",
    title: "Finance",
    subtitle: "Professionals",
  },
  {
    number: 21000,
    suffix: "+",
    title: "Management",
    subtitle: "Experts",
  },
  {
    number: 142,
    suffix: "%",
    title: "AI-skilled talent",
    subtitle: "growth (1 yr)",
  },
];

const financePoints = [
  "Gujarat has India's 2nd largest CA professional base (after Mumbai)",
  "IIM Ahmedabad - Asia's top finance & MBA institution",
  "Strong risk, compliance & actuarial talent pools",
  "CFA, FRM & ACCA professionals concentrated here",
];

const infraPoints = [
  "Plug-and-play Grade A offices - no setup delay",
  "12 km from Ahmedabad | 8 km from International Airport",
  "Mumbai-Ahmedabad High-Speed Rail (Under Construction)",
  "District Cooling, IoT Utilities & Tier-IV Data Centres",
];

const universities = [
  "IIM Ahmedabad",
  "IIT Gandhinagar (MoU with IFSCA)",
  "Nirma University",
  "Gujarat Technological University",
  "2 Australian Universities (Operational)",
  "Gujarat Maritime University",
];

const Talentinfrastructure = () => {
  return (
    <div>
      <section className="talent-section">
        <Container>
          <motion.div
            initial={{ opacity: 0, y: -30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            <p className="section-label">TALENT & INFRASTRUCTURE</p>

            <h2 className="section-title">A Rare Finance + Tech Talent Base</h2>
          </motion.div>

          {/* Statistics */}

          <Row className="g-4 mt-2">
            {stats.map((item, index) => (
              <Col lg={3} md={6} key={index}>
                <motion.div
                  className="stat-card"
                  whileHover={{ y: -10 }}
                  initial={{ opacity: 0, y: 60 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.2 }}
                  viewport={{ once: true }}
                >
                  <h2>
                    <CountUp end={item.number} duration={3} separator="," />

                    {item.suffix}
                  </h2>

                  <p>{item.title}</p>

                  <span>{item.subtitle}</span>
                </motion.div>
              </Col>
            ))}
          </Row>

          {/* Two Content Boxes */}

          <Row className="mt-4 g-4">
            <Col lg={6}>
              <motion.div
                className="info-box"
                initial={{ x: -80, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                viewport={{ once: true }}
              >
                <h4>Why Finance Talent Is Rare Here</h4>

                {financePoints.map((item, index) => (
                  <div className="point" key={index}>
                    <FaCheckSquare />

                    <span>{item}</span>
                  </div>
                ))}
              </motion.div>
            </Col>

            <Col lg={6}>
              <motion.div
                className="info-box"
                initial={{ x: 80, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                viewport={{ once: true }}
              >
                <h4>Infrastructure Advantage</h4>

                {infraPoints.map((item, index) => (
                  <div className="point" key={index}>
                    <FaCheckSquare />

                    <span>{item}</span>
                  </div>
                ))}
              </motion.div>
            </Col>
          </Row>

          {/* Universities */}

          <motion.div
            className="academy"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <h5>ACADEMIC ECOSYSTEM</h5>

            <Row>
              {universities.map((item, index) => (
                <Col lg={4} md={6} key={index}>
                  <div className="uni">
                    <FaCheckSquare />

                    <span>{item}</span>
                  </div>
                </Col>
              ))}
            </Row>
          </motion.div>

          {/* Footer */}

          <motion.div
            className="bottom-strip"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            Office rents 30–50% lower than Bengaluru &nbsp; | &nbsp; Talent
            salaries 20–35% below Mumbai &nbsp; | &nbsp; Lower hiring
            competition than other GCC hubs
          </motion.div>
        </Container>
      </section>
    </div>
  );
};

export default Talentinfrastructure;
